import { render, staticRenderFns } from "./kenmD.vue?vue&type=template&id=0e3f20c6&scoped=true"
import script from "./kenmD.vue?vue&type=script&lang=js"
export * from "./kenmD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3f20c6",
  null
  
)

export default component.exports